import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../AuthContext";
import AppHeader from "../components/AppHeader";
import SiteFooter from "../components/SiteFooter";

export default function Journal() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/journal`);
        setEntries(data.entries || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleDelete = async (entry_id) => {
    if (!window.confirm("Remove this reframe from your journal?")) return;
    setDeletingId(entry_id);
    try {
      await axios.delete(`${API}/journal/${entry_id}`);
      setEntries((prev) => prev.filter((e) => e.entry_id !== entry_id));
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="page" data-testid="journal-page">
      <div className="grain-bg" />
      <div className="container-narrow">
        <AppHeader showJournalCount journalCount={entries.length} />

        <div className="fade-in">
          <div className="eyebrow" style={{ marginBottom: 16 }}>Your reframes</div>
          <h1 className="display" data-testid="journal-heading">
            What you've turned.
          </h1>
          <div
            data-testid="journal-privacy-note"
            className="serif-italic"
            style={{ fontSize: 15, color: "var(--muted)", marginTop: -24, marginBottom: 40, lineHeight: 1.6 }}
          >
            Your private journal. Visible only to you.
          </div>

          {loading && (
            <div className="serif-italic shimmer" style={{ fontSize: 16, color: "var(--muted)" }}>
              loading…
            </div>
          )}

          {!loading && entries.length === 0 && (
            <div className="serif-italic" data-testid="empty-journal" style={{ fontSize: 18, color: "var(--muted)", lineHeight: 1.7 }}>
              Nothing here yet. Drop your first thought in and let it go.
              <div style={{ marginTop: 28 }}>
                <Link to="/app" className="btn-underline" data-testid="empty-journal-cta">
                  Begin →
                </Link>
              </div>
            </div>
          )}

          {entries.map((entry, i) => (
            <div
              key={entry.entry_id}
              className="fade-in-up"
              data-testid={`journal-entry-${i}`}
              style={{
                paddingBottom: 36,
                marginBottom: 36,
                borderBottom: i < entries.length - 1 ? "1px solid var(--hairline)" : "none",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div className="eyebrow">
                  {new Date(entry.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}
                </div>
                <button
                  onClick={() => handleDelete(entry.entry_id)}
                  disabled={deletingId === entry.entry_id}
                  className="nav-link"
                  data-testid={`delete-entry-${i}`}
                  style={{ fontSize: 10 }}
                >
                  {deletingId === entry.entry_id ? "…" : "Remove"}
                </button>
              </div>

              <div className="entry-thought" data-testid={`entry-thought-${i}`} style={{ WebkitFontSmoothing: "auto", MozOsxFontSmoothing: "auto" }}>{entry.thought}</div>

              <h3
                className="serif-italic"
                data-testid={`entry-heading-${i}`}
                style={{
                  fontWeight: 600, fontSize: 22, lineHeight: 1.3,
                  margin: "0 0 12px", color: "var(--ink)",
                  WebkitFontSmoothing: "auto", MozOsxFontSmoothing: "auto",
                }}
              >
                {entry.heading}
              </h3>

              <p
                data-testid={`entry-body-${i}`}
                style={{
                  fontSize: 15, lineHeight: 1.75, color: "var(--accent)",
                  margin: 0, marginBottom: entry.anchor ? 16 : 0, fontWeight: 600,
                  WebkitFontSmoothing: "auto", MozOsxFontSmoothing: "auto",
                }}
              >
                {entry.body}
              </p>

              {entry.anchor && (
                <div
                  className="serif-italic anchor-line"
                  data-testid={`entry-anchor-${i}`}
                  style={{ fontSize: 15, paddingTop: 12, lineHeight: 1.5 }}
                >
                  — {entry.anchor}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="footer-tag">Let Go. Live Free. Love Fully.</div>
      </div>
      <div className="container-narrow" style={{ paddingTop: 0, paddingBottom: 32 }}>
        <SiteFooter showTagline={false} />
      </div>
    </div>
  );
}
